import { render, staticRenderFns } from "./DependencyOptionsMenu.vue?vue&type=template&id=b5b88544&scoped=true&"
import script from "./DependencyOptionsMenu.vue?vue&type=script&lang=js&"
export * from "./DependencyOptionsMenu.vue?vue&type=script&lang=js&"
import style0 from "./DependencyOptionsMenu.vue?vue&type=style&index=0&id=b5b88544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b88544",
  null
  
)

export default component.exports